import React from 'react'
import Big from 'big.js'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons'

import formatUsdAmount from 'src/utils/formatUsdAmount'

const Payment = ({ priceData, goBack, handleSubmit, loading }) => {
  const orderCost = Big(priceData.order_cost)
  const shipping = Big(priceData.shipping)
  const taxes = Big(priceData.taxes)
  const total = orderCost.plus(shipping).plus(taxes)

  return (
    <form noValidate onSubmit={handleSubmit}>
      <h2 className="h5">Payment</h2>

      <div className="bg-light p-3 rounded-3 mb-3">
        <dl
          className="d-grid column-gap-4 mb-n2"
          style={{ gridTemplateColumns: 'auto max-content' }}
        >
          <dt>Sympathy Card</dt>
          <dd className="text-end">{formatUsdAmount(orderCost)}</dd>
          {
            shipping.gt(0) &&
            <>
              <dt>Shipping &amp; Handling</dt>
              <dd className="text-end">{formatUsdAmount(shipping)}</dd>
            </>
          }
          {
            taxes.gt(0) &&
            <>
              <dt>Sales Tax</dt>
              <dd className="text-end">{formatUsdAmount(taxes)}</dd>
            </>
          }
          {
            shipping.gt(0) || taxes.gt(0) &&
            <>
              <hr className="mt-0 mb-1 text-body-tertiary" />
              <hr className="mt-0 mb-1 text-body-tertiary ms-n4" />
              <dt>Total</dt>
              <dd className="text-end">{formatUsdAmount(total)}</dd>
            </>
          }
        </dl>
      </div>

      <div className="d-grid gap-2">
        <button
          className="btn btn-primary"
          disabled={loading}
        >
          {
            loading
            ? <>
                <FontAwesomeIcon icon={faCircleNotch} spin className="me-2" />
                Processing...
              </>
            : 'Purchase & Send Card'
          }
        </button>
        <button type="button" className="btn btn-link" onClick={goBack}>
          Go Back
        </button>
      </div>
    </form>
  )
}

const PaymentWrapper = ({ priceData, goBack, handleSubmit, loading }) =>
  !priceData ? null :
  <Payment
    priceData={priceData}
    goBack={goBack}
    handleSubmit={handleSubmit}
    loading={loading}
  />

export default PaymentWrapper
